var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_10241",
    "data-name": "Group 10241",
    xmlns: "http://www.w3.org/2000/svg",
    width: 37.487,
    height: 42.341,
    viewBox: "0 0 37.487 42.341",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "customer-svgrepo-com"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2802",
    "data-name": "Path 2802",
    d: "M26.9,16.424v-2.88H17.333v2.88a1.063,1.063,0,0,1-.82,1.035l-6.58,1.548a2.127,2.127,0,0,0-1.64,2.071v4.364a1.728,1.728,0,0,0,1.728,1.728H34.216a1.728,1.728,0,0,0,1.728-1.728V21.078a2.127,2.127,0,0,0-1.64-2.07l-6.58-1.548A1.063,1.063,0,0,1,26.9,16.424Z",
    transform: "translate(-4.837 4.802)",
    fill: "#e6af78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2803",
    "data-name": "Path 2803",
    d: "M34.3,17.917l-5.511-1.3a6.9,6.9,0,0,1-13.349,0l-5.511,1.3a2.127,2.127,0,0,0-1.64,2.07v4.364a1.728,1.728,0,0,0,1.728,1.728H34.216a1.728,1.728,0,0,0,1.728-1.728V19.987A2.127,2.127,0,0,0,34.3,17.917Z",
    transform: "translate(-4.837 5.892)",
    fill: "#ffd782"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2804",
    "data-name": "Path 2804",
    d: "M15.087,16.424a1.061,1.061,0,0,1-.459.872c6.309,3.161,10.031-3.089,10.031-3.089v-.663H15.087v2.88h0Z",
    transform: "translate(-2.591 4.802)",
    fill: "#d29b6e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2805",
    "data-name": "Path 2805",
    d: "M13.4,4.318l.463,10.194a3.191,3.191,0,0,0,1.273,2.408l2.2,1.649a3.19,3.19,0,0,0,1.914.638h2.127a3.19,3.19,0,0,0,1.914-.638l2.2-1.649a3.191,3.191,0,0,0,1.273-2.408l.463-10.194H13.4Z",
    transform: "translate(-3.027 1.531)",
    fill: "#f0c087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2806",
    "data-name": "Path 2806",
    d: "M13.4,4.318l.463,10.194a3.191,3.191,0,0,0,1.273,2.408l2.2,1.649a3.19,3.19,0,0,0,1.914.638h1.063c-1.6-.532-2.659-4.786-2.659-4.786l.058-5.19a.867.867,0,0,1,.746-.846c2.807-.409,6.389-1.217,8.768-3.571v-.5Z",
    transform: "translate(-3.027 1.531)",
    fill: "#e6af78"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2807",
    "data-name": "Path 2807",
    d: "M12.611,5.318v.532l.532,5.849h1.064L15.27,8.508s6.913,0,10.635-2.127L26.969,11.7h1.064l.532-5.849V5.318A5.318,5.318,0,0,0,23.246,0H17.929A5.317,5.317,0,0,0,12.611,5.318Z",
    transform: "translate(-3.306)",
    fill: "#5a4146"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2808",
    "data-name": "Path 2808",
    d: "M24.932,9.612l-.6,2.4a.639.639,0,0,1-.62.484h0a.639.639,0,0,1-.634-.56L22.77,9.481a1.1,1.1,0,0,1,1.092-1.237h0A1.1,1.1,0,0,1,24.932,9.612Z",
    transform: "translate(0.293 2.923)",
    fill: "#f0c087"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2809",
    "data-name": "Path 2809",
    d: "M12.645,9.612l.6,2.4a.639.639,0,0,0,.62.484h0a.639.639,0,0,0,.634-.56l.307-2.457a1.1,1.1,0,0,0-1.092-1.237h0A1.1,1.1,0,0,0,12.645,9.612Z",
    transform: "translate(-3.306 2.923)",
    fill: "#e6af78"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_10240",
    "data-name": "Group 10240",
    transform: "translate(3.456 22.512)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2810",
    "data-name": "Path 2810",
    d: "M12.2,21.228l-3.446-3.1a2.123,2.123,0,0,0-.458,1.318v4.364a1.728,1.728,0,0,0,1.728,1.728h3.058V23.206A2.659,2.659,0,0,0,12.2,21.228Z",
    transform: "translate(-8.293 -16.084)",
    fill: "#ffc36e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2811",
    "data-name": "Path 2811",
    d: "M26.056,21.228l3.446-3.1a2.123,2.123,0,0,1,.458,1.318v4.364a1.728,1.728,0,0,1-1.728,1.728H25.174V23.206A2.659,2.659,0,0,1,26.056,21.228Z",
    transform: "translate(-2.308 -16.084)",
    fill: "#ffc36e"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2812",
    "data-name": "Path 2812",
    d: "M27.361,16.62a6.9,6.9,0,0,1-13.349,0l-1.679.395.008.048a8.632,8.632,0,0,0,16.69,0l0-.049Z",
    transform: "translate(-6.861 -16.62)",
    fill: "#ffc36e"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_2815",
    "data-name": "Path 2815",
    d: "M8.626,30.516a1.834,1.834,0,0,1-1.377-1.377.046.046,0,0,0-.092,0A1.834,1.834,0,0,1,5.78,30.516a.046.046,0,0,0,0,.092,1.834,1.834,0,0,1,1.377,1.377.046.046,0,0,0,.092,0,1.834,1.834,0,0,1,1.377-1.377A.046.046,0,0,0,8.626,30.516Z",
    transform: "translate(-5.741 10.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2818",
    "data-name": "Path 2818",
    d: "M21.385,30.516a1.834,1.834,0,0,1-1.377-1.377.046.046,0,0,0-.092,0,1.834,1.834,0,0,1-1.377,1.377.046.046,0,0,0,0,.092,1.834,1.834,0,0,1,1.377,1.377.046.046,0,0,0,.092,0,1.834,1.834,0,0,1,1.377-1.377A.046.046,0,0,0,21.385,30.516Z",
    transform: "translate(-1.218 10.317)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2821",
    "data-name": "Path 2821",
    d: "M34.143,30.516a1.834,1.834,0,0,1-1.377-1.377.046.046,0,0,0-.092,0A1.834,1.834,0,0,1,31.3,30.516a.046.046,0,0,0,0,.092,1.834,1.834,0,0,1,1.377,1.377.046.046,0,0,0,.092,0,1.834,1.834,0,0,1,1.377-1.377A.046.046,0,0,0,34.143,30.516Z",
    transform: "translate(3.305 10.317)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/user-icon.a17eb60ee968883e4101b47f81ef5fab.svg";
export { ForwardRef as ReactComponent };